// This file is intended for any JS code that is required during front end design
// before the page-specific app is setup.
//
// This code should be refactored and moved to modules/widgets once the page-specific
// JS application is developed
$(function() {
  // console.log("Frontend JS code executed")
})
